// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'material-design-icons/iconfont/material-icons.css'
import '@recycling-umweltservice/fontawesome-pro/css/fontawesome.css'
import '@recycling-umweltservice/fontawesome-pro/css/regular.css'
import '@recycling-umweltservice/fontawesome-pro/css/solid.css'
import axios from 'axios/index'
import VueAxios from 'vue-axios'
import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import Vuetify from 'vuetify'
import de from 'vuetify/es5/locale/de'
import 'vuetify/dist/vuetify.min.css'
import JsonCSV from 'vue-json-csv'

Sentry.init({
  Vue: Vue,
  dsn: 'https://4c3265f63090469e93dbc7e5c75cf170@o321772.ingest.sentry.io/5703633',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.05,
  beforeSend (event, hint) {
    if (event.exception) {
      Sentry.showReportDialog({ eventId: event.event_id, user: {email: '', name: ''} })
    }
    return event
  }
})

axios.defaults.baseURL = process.env.API
const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  store.commit('LOADER', true)
  return config
}, function (error) {
  store.commit('LOADER', false)
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  store.commit('LOADER', false)
  return response
}, function (error) {
  store.commit('LOADER', false)
  return Promise.reject(error)
})
Vue.use(VueAxios, axios)

Vue.use(Vuetify)
const vuetifyOptions = {
  icons: {
    iconfont: 'fa',
    values: {
      prev: 'far fa-chevron-left',
      next: 'far fa-chevron-right',
      dropdown: 'fas fa-caret-down'
    }
  },
  lang: {
    locales: {de},
    current: 'de'
  },
  theme: {
    themes: {
      dark: {
        primary: '#EF6C00',
        secondary: '#8c9eff',
        accent: '#37474F'
      },
      light: {
        primary: '#EF6C00',
        secondary: '#8c9eff',
        accent: '#37474F'
      }
    }
  }
}

Vue.config.productionTip = false

Vue.component('downloadCsv', JsonCSV)

new Vue({
  router,
  store,
  vuetify: new Vuetify(vuetifyOptions),
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js